<template>
  <van-popup v-model="showPage" position="bottom" class="progressTopInfo" @close="onClosed">
    <van-row class="popTitle">
      <van-col span="4" />
      <van-col span="16" class="center" :style="'color:'+GetDiveMainBack()">进度管理</van-col>
      <van-col span="4" class="rigth"><i class="iconfont iconrigthjt" @click="showPage=false" /></van-col>
    </van-row>
    <div class="dataRect editRect">
      <van-row v-if="selectProgressInfo" gutter="10" class="values breakAll">
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()">顾客: </span>
          {{ selectProgressInfo.member.lastName+' '+selectProgressInfo.member.firstName }}
        </van-col>
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()">项目: </span>
          {{ selectProgressInfo.unit.unitName }}
        </van-col>
      </van-row>
      <van-row v-if="selectProgressInfo" gutter="10" class="values breakAll">
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()">发布: </span>
          {{ selectProgressInfo.progress?formatDate(selectProgressInfo.progress.createTime,'yyyy/MM/dd hh:mm',true):'-' }}
        </van-col>
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()">更新: </span>
          {{ selectProgressInfo.progress?formatDate(selectProgressInfo.progress.lastTime,'yyyy/MM/dd hh:mm',true):'-' }}
        </van-col>
      </van-row>
      <van-row v-if="selectProgressInfo" gutter="10" class="values breakAll">
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()">教练: </span>{{ selectProgressInfo.progress?selectProgressInfo.progress.coachName:'-' }}</van-col>
        <van-col span="12"><span :style="'color:'+GetDiveMainBack()" /></van-col>
      </van-row>
      <van-row gutter="10" class="values">
        <van-col span="5"><span :style="'color:'+GetDiveMainBack()">状态</span></van-col>
        <van-col span="19">
          <van-radio-group v-model="progressForm.state" :disabled="StudentProgressReadOnly" direction="horizontal" :checked-color="GetDiveMainBack()">
            <van-radio v-for="item in progressStateList" :key="item.value" class="radioItem" :name="item.value">{{ item.text }}</van-radio>
          </van-radio-group>
        </van-col>
      </van-row>
      <van-row v-if="progressForm.state==='FINISH'" gutter="10" class="values">
        <van-col span="5"><span :style="'color:'+GetDiveMainBack()">完成质量</span></van-col>
        <van-col span="19">
          <van-radio-group v-model="progressForm.completionState" :disabled="StudentProgressReadOnly" direction="horizontal" :checked-color="GetDiveMainBack()">
            <van-radio v-for="item in progressCompletionList" :key="item.value" class="radioItem" :name="item.value">{{ item.text }}</van-radio>
          </van-radio-group>
        </van-col>
      </van-row>
      <van-row gutter="10" class="values">
        <van-col span="5"><span :style="'color:'+GetDiveMainBack()">评语</span></van-col>
        <van-col span="19">
          <van-field v-model="progressForm.comment" :disabled="StudentProgressReadOnly" style="padding:0" placeholder="请输入评语" type="textarea" rows="1" autosize maxlength="256" show-word-limit />
        </van-col>
      </van-row>
      <van-row v-if="!StudentProgressReadOnly" gutter="10">
        <van-col span="12"><van-button :color="GetColorSecondary()" size="small" style="width:100%" :loading="buttonLoading" @click="onCleanProgressOne">清空进度</van-button></van-col>
        <van-col span="12"><van-button :color="GetDiveMainBack()" size="small" style="width:100%" :loading="buttonLoading" @click="onSaveProgressOne">保存进度</van-button></van-col>
      </van-row>
    </div>
  </van-popup>
</template>
<script>
import request from '@/utils/request'
import { Button, Popup, Field, Dialog, RadioGroup, Radio, Checkbox } from 'vant'
import { GetEnumList, formatDate, GetEnumText, MyNotify, getScoreText, GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
// import { formatDate } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.name]: Dialog,
    [Checkbox.name]: Checkbox
  },
  props: {
    // eslint-disable-next-line
    value: Boolean,
    // eslint-disable-next-line
    selectProgressInfo:undefined,
    // eslint-disable-next-line
    StudentProgressReadOnly:Boolean,
  },
  data() {
    return {
      showPage: false,
      buttonLoading: false,
      progressForm: {
        classId: undefined,
        isClean: false,
        completionState: 'Good',
        state: 'FINISH',
        comment: '',
        studentIds: [],
        unitIds: []

      },
      progressStateList: [],
      progressCompletionList: []
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.initEnum()
        console.log('this.selectProgressInfo', this.selectProgressInfo)
        if (this.selectProgressInfo.progress) {
          this.progressForm.completionState = this.selectProgressInfo.progress.completionState
          this.progressForm.state = this.selectProgressInfo.progress.state
          this.progressForm.comment = this.selectProgressInfo.progress.comment
        } else {
          this.progressForm.completionState = 'Good'
          this.progressForm.state = 'FINISH'
          this.progressForm.comment = ''
        }
        this.showPage = true
      } else {
        this.showPage = false
      }
    }

  },
  created() {

  },
  methods: {
    GetEnumList,
    formatDate,
    GetEnumText,
    MyNotify,
    getScoreText,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetColorMainLine,
    initEnum() {
      if (this.progressStateList.length <= 0) {
        this.progressStateList = GetEnumList('Em_DiveUnitState')
        this.progressCompletionList = GetEnumList('Em_CompletionState').filter(item => item.value !== 'UNFINISH' && item.value !== 'UNKNOW')
      }
    },
    onClosed() {
      console.log('onClosed')
      this.$emit('input', undefined)
    },
    onCleanProgressOne() {
      this.progressForm.isClean = true
      this.progressForm.classId = this.selectProgressInfo.member.diveClassId
      this.progressForm.studentIds = [this.selectProgressInfo.member.studentId]
      this.progressForm.unitIds = [this.selectProgressInfo.unit.diveCourseUnitId]
      this.buttonLoading = true
      request({
        url: '/DiveTrip/updateDiveProgress',
        method: 'post',
        data: this.progressForm
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '保存进度成功', 2000)
        this.$emit('reload')
        this.showPage = false
      })
    },
    onSaveProgressOne() {
      this.progressForm.isClean = false
      this.progressForm.classId = this.selectProgressInfo.member.diveClassId
      this.progressForm.studentIds = [this.selectProgressInfo.member.studentId]
      this.progressForm.unitIds = [this.selectProgressInfo.unit.diveCourseUnitId]
      console.log('progressForm', this.progressForm)
      this.buttonLoading = true
      request({
        url: '/DiveTrip/updateDiveProgress',
        method: 'post',
        data: this.progressForm
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '保存进度成功', 2000)
        this.$emit('reload')
        this.showPage = false
      })
    }

  }
}
</script>

<style scoped>
.progressTopInfo{
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
}
.progressTopInfo .dataRect
{
  padding: 0 0.5em;
  overflow: hidden;
  font-size: 0.8em;
  line-height: 1.5em;
}
.progressTopInfo .editRect
{
  padding-top: 0.5em;
  padding-bottom: 1em;
  line-height: 2.5em;
}
.progressTopInfo .popTitle
{
  padding: 0.5em 0.5em;
  border-bottom: 1px solid #f5f5f5;
}

</style>
